import React from "react";
import { Button, Stack, Typography } from "@mui/material";
import { CssTextField } from "../styles/styles";
import { useNavigate } from "react-router-dom";
import { Padding, PaletaColor } from "../styles/StylesConstantes";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';


function AddTransaccionComponents({
    name, handleName, cedula, handleCedula,
    apellido, handleApellido, email, handleEmail,
    telefono, handleTelefono, direccion, handleDireccion,
    fechaNacimiento, handleFechaNacimiento,
    handleGuardar, handleCancelar

}) {

    let history = useNavigate();






    return (
        <div style={{
            backgroundColor: PaletaColor.BLANCO,
            borderRadius: Padding.P1,
            padding: Padding.P3,
        }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant={'h5'} style={{}}>
                    Crear transacción
                </Typography>

            </div>


            <div style={{ marginTop: Padding.P1 }} >
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                    <div style={{ flex: 1 }}>
                        <div>
                            <Typography variant={'subtitle1'} style={{}}>
                                Nombre
                            </Typography>
                        </div>

                        <CssTextField
                            value={name}
                            onChange={(e) => handleName(e.target.value)}
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            label="Ingresar nombres"
                            id="name"
                            autoCapitalize='none'
                            autoCorrect={false}
                            // autoCompleteType='email'
                            style={{
                                marginTop: Padding.P1,
                                width: '95%'
                            }}
                        />

                    </div>

                    <div style={{ flex: 1 }}>
                        <div>
                            <Typography variant={'subtitle1'} style={{}}>
                                Apellido
                            </Typography>
                        </div>

                        <CssTextField
                            value={apellido}
                            onChange={(e) => handleApellido(e.target.value)}
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            label="Ingresar apellidos"
                            autoCapitalize='none'
                            autoCorrect={false}
                            style={{
                                marginTop: Padding.P1,
                                width: '95%'
                            }}
                        />
                    </div>

                    <div style={{ flex: 1 }}>
                        <div>
                            <Typography variant={'subtitle1'} style={{}}>
                                Cédula de identidad
                            </Typography>
                        </div>

                        <CssTextField
                            value={cedula}
                            onChange={(e) => handleCedula(e.target.value)}
                            variant="outlined"
                            //ingresar solo numeros
                            type="number"
                            margin="normal"
                            fullWidth
                            label="Ingresar cédula"
                            autoCapitalize='none'
                            autoCorrect={false}
                            style={{
                                marginTop: Padding.P1,
                                // width: '95%'
                            }}
                        />
                    </div>
                </div>




                <div style={{ display: 'flex', justifyContent: 'center', marginTop: Padding.P2 }}>
                    <div style={{ flex: 1, display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ flex: 1 }}>
                            <div>
                                <Typography variant={'subtitle1'} style={{}}>
                                    Email
                                </Typography>
                            </div>

                            <CssTextField
                                value={email}
                                onChange={(e) => handleEmail(e.target.value)}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                label="Ingresar email"
                                autoCapitalize='none'
                                autoCorrect={false}
                                style={{
                                    marginTop: Padding.P1,
                                    width: '95%'
                                }}
                            />
                        </div>

                        <div style={{ flex: 1 }}>
                            <div>
                                <Typography variant={'subtitle1'} style={{}}>
                                    Teléfono
                                </Typography>
                            </div>

                            <CssTextField
                                value={telefono}
                                onChange={(e) => handleTelefono(e.target.value)}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                label="Ingresar teléfono"
                                autoCapitalize='none'
                                autoCorrect={false}
                                style={{
                                    marginTop: Padding.P1,
                                    width: '95%'
                                }}
                            />
                        </div>

                        <div style={{ flex: 1 }}>
                            <div>
                                <Typography variant={'subtitle1'} style={{}}>
                                    Dirección
                                </Typography>
                            </div>

                            <CssTextField
                                value={direccion}
                                onChange={(e) => handleDireccion(e.target.value)}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                label="Ingresar dirección"
                                autoCapitalize='none'
                                autoCorrect={false}
                                style={{
                                    marginTop: Padding.P1,
                                    // width: '95%'
                                }}
                            />
                        </div>
                    </div>
                </div>






                <div style={{ display: 'flex', justifyContent: 'center', marginTop: Padding.P2 }}>
                    <div style={{ flex: 1, display: 'flex', justifyContent: 'space-between' }}>


                        <div style={{ flex: 1 }}>
                            <div>
                                <Typography variant={'subtitle1'} style={{}}>
                                    Fecha de nacimiento
                                </Typography>
                            </div>

                            <div style={{}}>
                                <LocalizationProvider adapterLocale="es" dateAdapter={AdapterDayjs}>

                                    <DatePicker
                                        label="Fecha de nacimiento"
                                        value={fechaNacimiento}
                                        onChange={(newValue) => {
                                            handleFechaNacimiento(newValue);
                                        }}
                                        format="DD/MM/YYYY"
                                    />
                                </LocalizationProvider>
                            </div>
                        </div>
                    </div>
                </div>


                <Stack direction="row" spacing={5} style={{ marginTop: Padding.P5 }}>
                    <Button variant="contained" onClick={handleGuardar}>
                        Actualizar
                    </Button>

                    <Button variant="outlined" onClick={handleCancelar}>
                        Cancelar
                    </Button>
                </Stack>

            </div>

        </div>
    )
}

export default AddTransaccionComponents;